import React from 'react';
import PropTypes from 'prop-types';
import { Link, ShareWhatsappIcon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';

function SocialShareWhatsapp({
  url,
  handleSocialLinkClick,
  linkTitle,
  color = grey600,
}) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'whatsapp')}
      title={linkTitle}
      style={{ color }}
      data-testid="social-share-whatsapp"
    >
      <ShareWhatsappIcon size="lg" />
    </Link>
  );
}

SocialShareWhatsapp.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareWhatsapp;
